import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const BudgetInput = () => {
  const { budgetId = '' } = useParams();
  const decodedId = budgetId ? atob(budgetId) : budgetId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [accounts, setAccounts] = useState([]);
  const route = 'budget';

  useEffect(() => {
    if (budgetId) {
      setIsEditing(true);
      fetchBudgetDetails();
    }
    fetchExistingAccounts();
  }, [budgetId]);

  const fetchBudgetDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.budget}${id}/`, { headers });
      const budgetDetails = response.data;

      setFormData(budgetDetails);
    } catch (error) {
      console.error('Error fetching budget details:', error);
    }
  };

  const fetchExistingAccounts = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.account}`, { headers });
      const existingAccounts = response.data.map((account) => ({
        value: account.id,
        label: account.name,
      }));

      setAccounts(existingAccounts);

      return existingAccounts;
    } catch (error) {
      console.error('Error fetching existing accounts:', error);
      return [];
    }
  };

  const budgetFields = [
    { name: 'name', label: 'Budget Name', type: 'text' },
    {
      name: 'account',
      label: 'Account',
      type: 'select',
      options: accounts,
    },
    { name: 'start_date', label: 'Start Date', type: 'date' },
    { name: 'end_date', label: 'End Date', type: 'date' },
    {
      name: 'allocated_amount',
      label: 'Allocated Amount',
      type: 'number',
      step: '0.01',
    },
    {
      name: 'spent_amount',
      label: 'Spent Amount',
      type: 'number',
      step: '0.01',
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Budget' : 'Create Budget'}</h1>
      <FormComponent fields={budgetFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default BudgetInput;